<template>
  <div class="reviews-page">
    <van-nav-bar fixed placeholder class="page-nav" :border="false">
      <template #title>
        <span class="page-title">Reviews</span>
      </template>
      <template #right>
        <van-icon name="home-o" class="home-icon" @click="$router.push('/Home')" />
      </template>
    </van-nav-bar>

    <div class="page-content">
      <article
        v-for="item in visibleReviews"
        :key="item.id"
        class="review-card"
      >
        <div class="review-head">
          <div class="avatar-circle">{{ item.initials }}</div>
          <div class="review-body">
            <div class="review-name">{{ item.name }}</div>
            <div class="stars">
              <img
                v-for="star in 5"
                :key="`${item.id}-${star}`"
                :src="starIcon"
                alt="star"
              >
            </div>
            <p class="review-text">{{ item.text }}</p>

            <img
              v-if="item.image"
              :src="item.image"
              :alt="item.name"
              class="review-image"
            >
          </div>
        </div>
      </article>

      <button
        v-if="reviews.length > initialVisibleCount"
        class="load-more-btn"
        @click="toggleReviews"
      >
        {{ expanded ? 'Show Less' : 'Load More' }}
      </button>
    </div>

    <button class="support-btn" @click="openSupport">
      <img src="https://m.sincereloves.online/icon/telegram.png" alt="Telegram">
    </button>
  </div>
</template>

<script>
const REVIEW_LIST = [
  {
    id: 1,
    initials: 'EL',
    name: 'El*na',
    text: "“I don't want bad women,” Giulia's profile stated. She wore orange tops in nearly every photo. I seized on this detail and messaged her: “Hey! Looks like orange is your favorite color. It looks great on you!” Turns out the orange outfits were just a coincidence. After chatting for a week, we defied the pandemic and arranged to walk together. Three weeks into dating, I made things official with her. We weathered two lockdowns in a small apartment, later adopted a cat, and got engaged on Formentera. She's my dream girl. We often wonder if fate would have brought us together without Sincere Love Dating Club. We may never know.",
    image: 'https://api.sincereloves.online/storage/20260208/uhN1770550341NvtyUl1.jpg'
  },
  {
    id: 2,
    initials: 'CH',
    name: 'Ch***er',
    text: 'Sincere Love Dating Club has beautiful women and cute cats. I will come here for a date next time'
  },
  {
    id: 3,
    initials: 'CH',
    name: 'Ch***es',
    text: 'I always need a woman to comfort me. The girls here are very friendly and make me feel good'
  },
  {
    id: 4,
    initials: 'TH',
    name: 'Th**as',
    text: 'Sincere Love Dating Club is a great platform and worth supporting'
  },
  {
    id: 5,
    initials: 'JO',
    name: 'Jo**ph',
    text: 'Sincere Love Dating Club is a great platform with fast matching speed, user-friendly interface and ease of use'
  },
  {
    id: 6,
    initials: 'RI',
    name: 'Ri***rd',
    text: 'Users on the platform feel genuine and the chat atmosphere is good'
  },
  {
    id: 7,
    initials: 'WI',
    name: 'Wi***am',
    text: 'We are glad that you can find like-minded friends on Sincere Love Dating Club platform, which is exactly what we are looking for'
  },
  {
    id: 8,
    initials: 'MI',
    name: 'Mi***el',
    text: 'The ladies here are very nice. I will come back next time'
  },
  {
    id: 9,
    initials: 'RO',
    name: 'Ro**rt',
    text: 'Thanks to Sincere Love Dating Club dating platform, my sweetheart and I are getting married next month'
  },
  {
    id: 10,
    initials: 'JO',
    name: 'John',
    text: 'I found it really fun to meet the girls at Sincere Love Dating Club. They were all very considerate and helpful'
  }
];

export default {
  data() {
    return {
      expanded: false,
      initialVisibleCount: 5,
      reviews: REVIEW_LIST,
      starIcon: 'https://m.sincereloves.online/icon/icon_star.png'
    };
  },
  computed: {
    visibleReviews() {
      return this.expanded
        ? this.reviews
        : this.reviews.slice(0, this.initialVisibleCount);
    }
  },
  methods: {
    toggleReviews() {
      this.expanded = !this.expanded;
    },
    openSupport() {
      const service = this.$store.getters.getBaseInfo || {};
      if (service.iskefu == 1 && service.kefu) {
        window.location.href = service.kefu;
        return;
      }
      this.$router.push('/ServiceOnline');
    }
  }
};
</script>

<style lang="less" scoped>
.reviews-page {
  min-height: 100vh;
  background: #000;
  color: #fff;
}

.page-nav {
  min-height: 72px;
  background: #1c1c1e;
}

::v-deep .page-nav .van-nav-bar {
  background: #1c1c1e;
  box-shadow: none;
}

::v-deep .page-nav .van-nav-bar__content {
  height: 72px;
}

.page-title {
  color: #e6b98a;
  font-size: 20px;
  font-weight: 700;
}

.home-icon {
  color: #e6b98a;
  font-size: 24px;
}

.page-content {
  padding: 20px 14px 120px;
}

.review-card {
  margin-bottom: 22px;
  padding: 24px;
  border: 1px solid #766350;
  border-radius: 20px;
  background: linear-gradient(90deg, #212121, #313131);
}

.review-head {
  display: flex;
  align-items: flex-start;
}

.avatar-circle {
  display: flex;
  width: 72px;
  height: 72px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #98d8c8;
  color: #ffffff;
  font-size: 28px;
  font-weight: 700;
  flex-shrink: 0;
}

.review-body {
  flex: 1;
  margin-left: 22px;
}

.review-name {
  color: #e1e1e1;
  font-size: 22px;
  font-weight: 800;
}

.stars {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 14px;
}

.stars img {
  width: 24px;
  height: 24px;
  margin-right: 6px;
}

.review-text {
  margin: 0;
  color: #a9896e;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.6;
}

.review-image {
  display: block;
  width: 100%;
  margin-top: 18px;
  border-radius: 8px;
}

.load-more-btn {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 20px 0;
  border: 1px solid #766350;
  border-radius: 16px;
  background: linear-gradient(180deg, #393939, #252525);
  color: #f0be88;
  font-size: 20px;
  font-weight: 700;
}

.support-btn {
  position: fixed;
  right: 22px;
  bottom: 142px;
  z-index: 30;
  display: flex;
  width: 92px;
  height: 92px;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: #ff2f34;
  box-shadow: 0 0 18px rgba(255, 66, 87, 0.55);
}

.support-btn img {
  width: 40px;
  height: 40px;
}
</style>
